const app = {
  name: 'TrawlBens',
  description: ''
}

export default app
